var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-col",
        { staticClass: "ma-0 pa-0", attrs: { cols: "12", id: "header" } },
        [
          _c(
            "v-col",
            {
              staticClass: "pa-0",
              attrs: { cols: "12", id: "main_content_maxwidthset" },
            },
            [
              _c(
                "v-row",
                {
                  staticClass: "ma-0 pa-0",
                  attrs: {
                    align: "center",
                    justify: "space-between",
                    id: "header_body",
                  },
                },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-0",
                      attrs: { cols: "2", id: "header_text" },
                    },
                    [_vm._v(" " + _vm._s(_vm.tn("notiTitle")) + " ")]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "ma-0 pa-0", attrs: { cols: "10" } },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: { align: "center", justify: "end" },
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0 pr-4",
                              staticStyle: { width: "10rem" },
                              attrs: { cols: "auto" },
                            },
                            [
                              _c("v-select", {
                                staticClass: "notice_select ma-0 pa-1",
                                attrs: {
                                  items: _vm.noticeList,
                                  dense: "",
                                  "hide-details": "",
                                  outlined: "",
                                  dark: "",
                                  "item-text": "label",
                                  "item-value": "value",
                                },
                                model: {
                                  value: _vm.selectedCategory,
                                  callback: function ($$v) {
                                    _vm.selectedCategory = $$v
                                  },
                                  expression: "selectedCategory",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-col",
        {
          staticClass: "pa-0 sticky_body",
          attrs: { id: "main_content_maxwidthset", cols: "12" },
        },
        [
          _c(
            "v-row",
            {
              staticClass: "pa-0 ma-0 mt-10 mb-10",
              attrs: { justify: "center" },
            },
            [
              _vm.fetchLoading == false
                ? [
                    _vm.filteredNotificationList.length > 0
                      ? _vm._l(
                          _vm.filteredNotificationList,
                          function (item, index) {
                            return _c(
                              "v-col",
                              {
                                key: index,
                                staticClass: "ma-0 pa-0 mb-7",
                                attrs: { cols: "10" },
                              },
                              [
                                _c(
                                  "v-row",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { id: "list_date" },
                                  },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "ma-0 pa-0 date_text",
                                        attrs: { cols: "auto" },
                                      },
                                      [_vm._v(" " + _vm._s(item.date) + " ")]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-list",
                                  { staticClass: "notification_list" },
                                  _vm._l(
                                    item.subNotificationList,
                                    function (detail, index_detail) {
                                      return _c(
                                        "v-list-item",
                                        {
                                          key: index_detail,
                                          staticClass: "detail_group",
                                          on: {
                                            click: function ($event) {
                                              return _vm.notiDetailView(detail)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-list-item-content",
                                            { staticClass: "ma-0 pa-0" },
                                            [
                                              _c(
                                                "v-row",
                                                { staticClass: "ma-0 pa-0" },
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass:
                                                        "ma-0 pa-0 detail_title",
                                                      attrs: { cols: "auto" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(detail.title) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c("v-spacer"),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "ma-0 pa-0",
                                                      attrs: { cols: "auto" },
                                                    },
                                                    [
                                                      _c("v-img", {
                                                        staticClass:
                                                          "ma-0 pa-0",
                                                        attrs: {
                                                          src: require("@/assets/images/right_btn.png"),
                                                          "max-height": "2rem",
                                                          "max-width": "2rem",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            )
                          }
                        )
                      : [
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-15 mb-7",
                              attrs: { cols: "10" },
                            },
                            [_vm._v(" " + _vm._s(_vm.t("noData")) + " ")]
                          ),
                        ],
                  ]
                : [
                    _c(
                      "v-col",
                      { staticClass: "ma-0 pa-15 mb-7", attrs: { cols: "10" } },
                      [
                        _c("v-progress-circular", {
                          attrs: {
                            indeterminate: "",
                            color: "white",
                            width: 4,
                            size: 40,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }